/**
 * @generated SignedSource<<e21133d2a7e25e27191002eda75f39a2>>
 * @relayHash 2837a7a5a65ba4a79cb33f25695dc0e4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7ea62d878147d8dfff029fb3f9626a066e2ee4ce2ee5c45d59bb23769c18d9d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery$variables = {
  boardIdAri: string;
  cloudId: string;
  isCMP?: boolean | null | undefined;
  isIssueLinkingFromBoardCardEnabled: boolean;
};
export type issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery$data = {
  readonly boardScope?: {
    readonly currentUser: {
      readonly permissions: ReadonlyArray<AGG$SoftwareBoardPermission | null | undefined>;
    };
  } | null | undefined;
  readonly jira?: {
    readonly issueLinkTypes: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly inwards: string;
          readonly outwards: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery = {
  response: issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery$data;
  variables: issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "boardIdAri"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isCMP"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isIssueLinkingFromBoardCardEnabled"
},
v4 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "inwards"
},
v7 = {
  "kind": "ScalarField",
  "name": "outwards"
},
v8 = [
  {
    "kind": "Variable",
    "name": "boardId",
    "variableName": "boardIdAri"
  },
  {
    "kind": "Variable",
    "name": "isCMP",
    "variableName": "isCMP"
  }
],
v9 = {
  "concreteType": "CurrentUser",
  "kind": "LinkedField",
  "name": "currentUser",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "permissions"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
    "selections": [
      {
        "condition": "isIssueLinkingFromBoardCardEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraIssueLinkTypeConnection",
                "kind": "LinkedField",
                "name": "issueLinkTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueLinkTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueLinkType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "RequiredField",
                            "field": (v5/*: any*/),
                            "action": "THROW",
                            "path": "jira.issueLinkTypes.edges.node.id"
                          },
                          {
                            "kind": "RequiredField",
                            "field": (v6/*: any*/),
                            "action": "THROW",
                            "path": "jira.issueLinkTypes.edges.node.inwards"
                          },
                          {
                            "kind": "RequiredField",
                            "field": (v7/*: any*/),
                            "action": "THROW",
                            "path": "jira.issueLinkTypes.edges.node.outwards"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "BoardScope",
            "kind": "LinkedField",
            "name": "boardScope",
            "plural": false,
            "selections": [
              (v9/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
    "selections": [
      {
        "condition": "isIssueLinkingFromBoardCardEnabled",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraIssueLinkTypeConnection",
                "kind": "LinkedField",
                "name": "issueLinkTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueLinkTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueLinkType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v8/*: any*/),
            "concreteType": "BoardScope",
            "kind": "LinkedField",
            "name": "boardScope",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d7ea62d878147d8dfff029fb3f9626a066e2ee4ce2ee5c45d59bb23769c18d9d",
    "metadata": {},
    "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a5caae57876b19ac5c24b470161b429e";

export default node;
